import styled from 'styled-components';
import { NARROW } from '@/breakpoints.js';

// A modal panel over the page (the credits, the contact form): a native <dialog>, for its focus
// trap, Escape key and backdrop, with a head that stays put and a body that scrolls

// The longest the panel grows before its list scrolls inside it
const MAX_HEIGHT = 'min(36em, calc(100dvh - 4em))';

export const Dialog = styled.dialog`
	box-sizing: border-box;
	width: min(34em, calc(100vw - 2em));
	max-height: ${MAX_HEIGHT};
	padding: 0;
	overflow: hidden;
	/* The header it is rendered in lets presses through to the canvas; the panel must take them */
	pointer-events: auto;
	border: 1px solid #ccc;
	border-radius: 0.75em;
	background: #fff;
	color: #222;
	box-shadow: 0 1em 3em #0005;

	&::backdrop {
		background: #0006;
	}

	${NARROW} {
		width: calc(100vw - 1em);
		max-height: calc(100dvh - 1em);
	}
`;

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	max-height: ${MAX_HEIGHT};

	${NARROW} {
		max-height: calc(100dvh - 1em);
	}
`;

// The title, centred in the panel. The close button sits over its corner, out of the flow, so that
// it does not push the title off centre; the title keeps clear of it on both sides.
export const Head = styled.div`
	position: relative;
	flex-shrink: 0;
	padding: 1em 3.5em 0.75em;
	border-bottom: 1px solid #eee;
	text-align: center;

	h2 {
		margin: 0;
		font-size: 1.15em;
	}

	small {
		display: block;
		margin-top: 0.2em;
		font-size: 0.75em;
		font-weight: 400;
		letter-spacing: 0.06em;
		text-transform: uppercase;
		opacity: 0.6;
	}
`;

export const Close = styled.button`
	position: absolute;
	inset-block-start: 0.4em;
	inset-inline-end: 0.5em;
	min-width: 44px;
	min-height: 44px;
	border: 0;
	border-radius: 0.5em;
	background: none;
	color: inherit;
	font: inherit;
	font-size: 1.4em;
	line-height: 1;
	cursor: pointer;

	&:hover {
		background: #f2f2f2;
	}
`;

export const Body = styled.div`
	/* Without a zero minimum a flex item never shrinks below its content, and so never scrolls */
	min-height: 0;
	overflow-y: auto;
	overscroll-behavior: contain;
	padding: 0.25em 1.25em 1em;
	font-size: 0.9em;
	line-height: 1.5;

	h3 {
		margin: 1.25em 0 0.4em;
		font-size: 0.8em;
		letter-spacing: 0.06em;
		text-transform: uppercase;
		opacity: 0.6;
	}

	p {
		margin: 0.75em 0 0;
	}

	ul {
		margin: 0;
		padding: 0;
		list-style: none;
	}

	li {
		padding: 0.35em 0;
		border-bottom: 1px solid #f0f0f0;
		overflow-wrap: anywhere;
	}

	a {
		color: #d03;
	}
`;
